import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { $getRoot } from "lexical";

export default function WordCountPlugin({ onWordCountChange }) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        const calculateWordCount = () => {
            editor.getEditorState().read(() => {
                const text = $getRoot().getTextContent();
                const words = text.trim().split(/\s+/).filter(Boolean);
                const count = words.length;
                onWordCountChange(count);
            });
        };

        calculateWordCount();

        return editor.registerUpdateListener(() => {
            calculateWordCount();
        });
    }, [editor, onWordCountChange]);

    return null;
}